/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { NurseIntakeOutputApi } from '../api/nurseintakeoutput.api';
import { switchMap, map } from 'rxjs/operators';
import { NurseIntakeOutput,NurseIntakeOutputData } from '../../../interfaces/Ip/nurseintakeoutput';

@Injectable()
export class NurseIntakeOutputService extends NurseIntakeOutputData {

  constructor(private api: NurseIntakeOutputApi) {
    super();
  }


  list(url: string): Observable<NurseIntakeOutput[]> {
    return this.api.list(url);
  }

  getById(url: string): Observable<NurseIntakeOutput>{
      return this.api.getById(url);
  }

  create(url: string, data: NurseIntakeOutput): Observable<NurseIntakeOutput[]> {
    return this.api.add(url,data);
  }

  update(url: string, data: NurseIntakeOutput): Observable<NurseIntakeOutput> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
